// extracted by mini-css-extract-plugin
module.exports = {"statsItem":"statsItem__oncSn","blockItem":"blockItem__a2iaL","text":"text__EjUN+","count":"count__7GDkX","userStats":"userStats__UDq6R"};